import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { MediaViewerWithMediaClient } from './media-viewer';
export var MediaViewerWithErrorBoundary = function MediaViewerWithErrorBoundary(props) {
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: function FallbackComponent() {
      return null;
    }
  }, /*#__PURE__*/React.createElement(MediaViewerWithMediaClient, props));
};